/** @jsxImportSource @emotion/react */
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { WorkflowEditorPageMapSources } from "./MapSources/WorkflowEditorPageMapSources";
import { WorkflowEditorPageOutputs } from "./Outputs/WorkflowEditorPageOutputs";
import { WorkflowEditorPageTableInfo } from "./TableInfo/WorkflowEditorPageTableInfo";
import { EuiModalBody } from "@inscopix/ideas-eui";
import { css } from "@emotion/react";
import { WorkflowEditorPageNameAndKey } from "./WorkflowEditorPageNameAndKey";

export const WorkflowEditorPages = () => {
  const page = useWorkflowEditorContext((s) => s.page);

  return (
    <EuiModalBody
      css={css`
        flex: 1;
        display: flex;
        min-height: 0;
        overflow: auto;
      `}
    >
      {(() => {
        switch (page) {
          case "TABLES":
            return <WorkflowEditorPageTableInfo />;
          case "SOURCES":
            return <WorkflowEditorPageMapSources />;
          case "OUTPUTS":
            return <WorkflowEditorPageOutputs />;
          case "NAME":
            return <WorkflowEditorPageNameAndKey />;
        }
      })()}
    </EuiModalBody>
  );
};
